import Axios from 'axios';

// Base url
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem('token');
const config = {
  headers: {
    authorization: token,
  },
};

export const listPosts = async () => {
  try {
    // Return the response
    return await Axios.get(`${apiUrl}/api/posts`, config);
  } catch (error) {
    throw new Error(error.message);
  }
};

// API call to create an account
export const registerAdmin = async (admin) => {
  try {
    // Return the response
    return await Axios.post(`${apiUrl}/api/admins/register`, admin);
  } catch (error) {
    throw new Error(error.message);
  }
};

// API call to login
export const loginAdmin = async (admin) => {
  try {
    // Return the response
    return await Axios.post(`${apiUrl}/api/admins/login`, admin);
  } catch (error) {
    throw new Error(error.message);
  }
};

// API call for profile
export const profileAdmin = async (token) => {
  try {
    // Return the response
    return await Axios.get(`${apiUrl}/api/admins/profile`, {
      headers: {
        authorization: token,
      },
    });
  } catch (error) {
    throw new Error(error.message);
  }
};

// API call for total number of Posts
export const getTotalPostsByStatus = async (token) => {
  try {
    // Return the response
    return await Axios.get(`${apiUrl}/api/posts/getTotalPostsByStatus`, {
      headers: {
        authorization: token,
      },
    });
  } catch (error) {
    throw new Error(error.message);
  }
};

// API call for total number of Posts
export const getCategoryCounts = async (token) => {
  try {
    // Return the response
    return await Axios.get(`${apiUrl}/api/posts/getCategoryCounts`, {
      headers: {
        authorization: token,
      },
    });
  } catch (error) {
    throw new Error(error.message);
  }
};
// API call for total number of Posts
export const getMonthlyPostCounts = async (token) => {
  try {
    // Return the response
    return await Axios.get(`${apiUrl}/api/posts/getMonthlyPostCounts`, {
      headers: {
        authorization: token,
      },
    });
  } catch (error) {
    throw new Error(error.message);
  }
};
